@if (!child) {
  <div
    class="mega-branch-trigger"
    [ngClass]="{
      'fuse-horizontal-navigation-menu-active': megaOpen,
      'fuse-horizontal-navigation-menu-active-forced':
        item.active || hasActiveChild,
    }"
    (mouseenter)="onTriggerMouseEnter()"
    (mouseleave)="onTriggerMouseLeave()"
    (click)="onTriggerClick(); $event.stopPropagation()"
    #triggerRef
  >
    <ng-container
      *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
    ></ng-container>
  </div>
}

<ng-template #megaTemplate>
  <div
    class="app-mega-menu-shell max-h-[min(70vh,800px)] overflow-auto rounded-xl border border-[color:var(--app-mega-divider)] bg-[color:var(--app-mega-panel-bg)] p-5 shadow-2xl outline-none"
    tabindex="-1"
    role="menu"
    (click)="onPanelClick($event)"
    (mouseenter)="onPanelMouseEnter()"
    (mouseleave)="onPanelMouseLeave()"
    (keydown)="onMegaMenuKeydown($event)"
  >
    <div class="app-mega-menu-grid flex items-stretch">
      @for (lane of lanes; track trackLane($index, lane)) {
        <div
          class="app-mega-menu-lane flex min-w-[220px] max-w-[300px] flex-col border-l border-[color:var(--app-mega-divider)] px-6 first:border-l-0 first:pl-0 last:pr-0"
        >
          @for (col of lane; track trackCol($index, col); let colIndex = $index) {
            <div
              class="app-mega-menu-column w-full min-w-0"
              [class.mt-5]="hasGapBefore(col, lane[colIndex - 1])"
            >
              @if (!col.plain) {
                <div class="mb-2 flex items-center gap-2.5">
                  <span
                    class="flex size-6 shrink-0 items-center justify-center rounded-full bg-[color:var(--app-mega-accent)] shadow-sm"
                  >
                    <mat-icon
                      class="icon-size-3 text-white"
                      [svgIcon]="col.icon"
                    ></mat-icon>
                  </span>
                  <span
                    class="min-w-0 flex-1 border-b-2 border-[color:var(--app-mega-accent-soft)] pb-1.5 text-base font-bold text-[color:var(--app-mega-accent)]"
                  >
                    {{ col.title }}
                  </span>
                </div>
              }
              @for (section of col.sections; track $index) {
                @if (section.subtitle) {
                  <div
                    class="mb-0.5 mt-2 px-3 text-sm font-semibold uppercase tracking-wide text-[color:var(--app-mega-muted)]"
                  >
                    {{ section.subtitle }}
                  </div>
                }
                @for (link of section.links; track trackLink($index, link)) {
                  @if (link.link && !link.externalLink && !link.disabled) {
                    <a
                      class="app-mega-menu-link flex items-center gap-2 rounded-md px-3 py-1.5 text-md font-medium"
                      [routerLink]="link.link"
                      [queryParams]="link.queryParams ?? undefined"
                      [fragment]="link.fragment ?? undefined"
                      [queryParamsHandling]="link.queryParamsHandling ?? undefined"
                      routerLinkActive="app-mega-menu-link--active"
                      [routerLinkActiveOptions]="{
                        exact: link.exactMatch ?? false,
                      }"
                      (click)="onInternalLinkClick($event, link)"
                    >
                      <span class="min-w-0 flex-1">{{ link.title }}</span>
                     
                    </a>
                  } @else if (link.link && link.externalLink) {
                    <a
                      class="app-mega-menu-link flex items-center gap-2 rounded-md px-3 py-1.5 text-md font-medium"
                      [attr.href]="link.link"
                      [attr.target]="link.target || '_blank'"
                      (click)="onLinkClick()"
                    >
                      <span class="min-w-0 flex-1">{{ link.title }}</span>
                      
                    </a>
                  }
                }
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template let-item #itemTemplate>
  <div
    class="fuse-horizontal-navigation-item-wrapper"
    [class.fuse-horizontal-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="item.classes?.wrapper"
  >
    <div
      class="fuse-horizontal-navigation-item"
      [ngClass]="{
        'fuse-horizontal-navigation-item-disabled': item.disabled,
        'fuse-horizontal-navigation-item-active-forced': item.active,
      }"
      [matTooltip]="item.tooltip || ''"
    >
      @if (item.icon) {
        <mat-icon
          class="fuse-horizontal-navigation-item-icon"
          [ngClass]="item.classes?.icon"
          [svgIcon]="item.icon"
        ></mat-icon>
      }
      <div class="fuse-horizontal-navigation-item-title-wrapper">
        <div class="fuse-horizontal-navigation-item-title">
          <span [ngClass]="item.classes?.title">{{ item.title }}</span>
        </div>
        @if (item.subtitle) {
          <div
            class="fuse-horizontal-navigation-item-subtitle text-hint"
          >
            <span [ngClass]="item.classes?.subtitle">{{
              item.subtitle
            }}</span>
          </div>
        }
      </div>
      @if (item.badge) {
        <div class="fuse-horizontal-navigation-item-badge">
          <div
            class="fuse-horizontal-navigation-item-badge-content"
            [ngClass]="item.badge.classes"
          >
            {{ item.badge.title }}
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
